import { Link, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { navigationItems, NavigationItemType } from './navigationItems'
import { NavLink, NavLinkProps } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { theme } from '@/theme'
import { forwardRef } from 'react'
import { User, UserGroup, UserGroups } from '@/types'
import { isUserInAnyGroup } from '@/utils/user'

const getAvailablePages = (
  user: Pick<User, 'groups' | 'can_report_manual_hours'>,
  navigationItems: NavigationItemType[]
) =>
  navigationItems.filter(({ group, href }) => {
    if (
      href === '/manual-hours-reporting' &&
      isUserInAnyGroup(user.groups, [
        UserGroups.EMPLOYEE,
        UserGroups.MANAGER,
        UserGroups.SOUND_TECHNICIAN,
        UserGroups.DATA_CONTROLLER,
      ]) &&
      !user.can_report_manual_hours
    ) {
      return false
    }

    if (!group) {
      return true
    }

    return group.some((g) => user.groups.includes(g))
  })

const RefNavLink = forwardRef<HTMLAnchorElement, NavLinkProps>((props, ref) => (
  <NavLink
    {...props}
    style={({ isActive }) => ({
      color: isActive ? theme.palette.text.primary : theme.palette.primary.main,
    })}
    ref={ref}
    to={props.to}
  />
))

export const NavbarMenuItems = (): JSX.Element => {
  const { t } = useTranslation('common')
  const { user } = useAuth()
  const availablePages = user?.groups
    ? getAvailablePages(
        {
          groups: user.groups as UserGroup[],
          can_report_manual_hours: (user as User).can_report_manual_hours,
        },
        navigationItems
      )
    : []

  return (
    <Stack direction="row" alignItems="center" spacing={6}>
      {availablePages.map(({ title, href }) => (
        <Link key={title} component={RefNavLink} to={href}>
          <Typography>{t(title)}</Typography>
        </Link>
      ))}
    </Stack>
  )
}
